import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ApiModel } from 'models';

@Injectable()
export class AppTranslateLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private apiModel: ApiModel
    ) {}

    getTranslation(lang: string): Observable<any> {
        return this.http.get(`${this.apiModel.getTranslationsEndpoint()}/${lang}`);
    }
}

export const AppTranslateLoaderProvider = { provide: TranslateLoader, useClass: AppTranslateLoader };

export const AppTranslateModule = TranslateModule.forRoot({ loader: AppTranslateLoaderProvider });
